var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transfer-record"},[_c('Table',{attrs:{"tableData":_vm.tableData,"titleList":_vm.titleList,"orientation":'center',"height":'calc(100vh - 200px)',"total":_vm.total,"headerStyle":_vm.headerStyle,"page":false,"loading":_vm.transferLoading},on:{"handleCurrentChange":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }